import React, { ReactElement } from "react";

interface Image {
  src: string;
  alt?: string;
}

interface Props {
  images?: Image[];
  overlay?: string | ReactElement;
}

export default function CareersImageGrid({
  images = [
    {
      src:
        "//cdnimg.webstaurantstore.com/uploads/design/2017/2/career-grid-3.jpg",
    },
    {
      src:
        "//cdnimg.webstaurantstore.com/images/products/large/471188/1856227.jpg",
    },
    {
      src:
        "//cdnimg.webstaurantstore.com/uploads/design/2017/2/career-grid-6.jpg",
    },
    {
      src:
        "//cdnimg.webstaurantstore.com/uploads/design/2017/2/career-grid-9.jpg",
    },
    {
      src:
        "//cdnimg.webstaurantstore.com/images/products/large/529042/1933261.jpg",
    },
    {
      src:
        "//cdnimg.webstaurantstore.com/uploads/design/2017/2/career-grid-8.jpg",
    },
    {
      src:
        "//cdnimg.webstaurantstore.com/uploads/design/2017/2/career-grid-2.jpg",
    },
    {
      src:
        "//cdnimg.webstaurantstore.com/images/products/large/533563/1994493.jpg",
    },
    {
      src:
        "//cdnimg.webstaurantstore.com/uploads/design/2017/2/career-grid-27.jpg",
    },
    {
      src:
        "//cdnimg.webstaurantstore.com/uploads/design/2017/2/career-grid-1.jpg",
    },
    {
      src:
        "//cdnimg.webstaurantstore.com/uploads/design/2017/2/career-grid-7.jpg",
    },
    {
      src:
        "//cdnimg.webstaurantstore.com/uploads/design/2017/2/career-grid-14.jpg",
    },
    {
      src:
        "//cdnimg.webstaurantstore.com/images/products/large/503313/1975506.jpg",
    },
    {
      src:
        "//cdnimg.webstaurantstore.com/uploads/design/2017/2/career-grid-16.jpg",
    },
    {
      src:
        "//cdnimg.webstaurantstore.com/uploads/design/2017/2/career-grid-29.jpg",
    },
    {
      src:
        "//cdnimg.webstaurantstore.com/uploads/design/2017/2/career-grid-18.jpg",
    },
    {
      src:
        "//cdnimg.webstaurantstore.com/uploads/design/2017/2/career-grid-21.jpg",
    },
    {
      src:
        "//cdnimg.webstaurantstore.com/uploads/design/2017/2/career-grid-41.jpg",
    },
    {
      src:
        "//cdnimg.webstaurantstore.com/images/products/large/491315/1894711.jpg",
    },
    {
      src:
        "//cdnimg.webstaurantstore.com/uploads/design/2017/2/career-grid-20.jpg",
    },
    {
      src:
        "//cdnimg.webstaurantstore.com/images/products/large/475322/1907188.jpg",
    },
    {
      src:
        "//cdnimg.webstaurantstore.com/uploads/design/2017/2/career-grid-23.jpg",
    },
    {
      src:
        "//cdnimg.webstaurantstore.com/uploads/design/2017/2/career-grid-19.jpg",
    },
  ],
  overlay = (
    <img
      src="//cdnimg.webstaurantstore.com/uploads/design/2017/5/lifeatweb.png"
      alt="Life At WebstaurantStore"
    />
  ),
}: Props) {
  return (
    <div className="careers-grid">
      <div className="careers-grid-container">
        {images.map((singleImage) => (
          <div
            className="careers-grid__image-wrap"
            key={encodeURIComponent(singleImage.src.toLowerCase())}
          >
            <img src={singleImage.src} alt={singleImage.alt ?? ""} />
          </div>
        ))}
      </div>
      <div className="careers-grid-overlay">
        <div className="careers-grid-overlay-content">
          <span>{overlay}</span>
        </div>
      </div>
    </div>
  );
}
